import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = { style: {"font-size":"36px","font-weight":"bold"} }
const _hoisted_5 = { style: {"font-size":"36px","font-weight":"bold"} }
const _hoisted_6 = { style: {"font-size":"36px","font-weight":"bold"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_breadcrumbs, {
      class: "px-0",
      items: _ctx.breadcrumbs
    }, null, 8, ["items"]),
    (_ctx.isNew)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("h2", null, "Extended Childcare Diary - New", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.displayDate), 1),
          _createVNode(_component_v_spacer),
          (_ctx.isApplied && (_ctx.isDirector || _ctx.isChief))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateApprovalStatus(true))),
                  disabled: 
            (_ctx.isChief && _ctx.isApprovedByChief) ||
            (_ctx.isDirector && _ctx.isApprovedByDirector)
          ,
                  color: "primary",
                  class: "mr-4",
                  variant: "flat",
                  size: "large"
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Approve", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                (
            (_ctx.isChief && _ctx.isApprovedByChief) ||
            (_ctx.isDirector && _ctx.isApprovedByDirector)
          )
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateApprovalStatus(false))),
                      color: "error",
                      variant: "outlined",
                      size: "large"
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("Revoke Approval", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 2,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    (!_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 3,
          class: "mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: "Director",
                  readonly: "",
                  variant: "outlined",
                  "model-value": _ctx.directorApproveStamp
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: "Chief",
                  readonly: "",
                  variant: "outlined",
                  "model-value": _ctx.cheifApproveStamp
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.staffItems,
                  label: "Staff",
                  multiple: "",
                  "item-title": "name",
                  "item-value": "userId",
                  variant: "outlined",
                  clearable: "",
                  modelValue: _ctx.inputValue.staff,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValue.staff) = $event))
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.staffItems,
                  label: "Applicant",
                  "item-title": "name",
                  "item-value": "userId",
                  variant: "outlined",
                  clearable: "",
                  modelValue: _ctx.inputValue.appliedBy,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValue.appliedBy) = $event))
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 4 }, {
          default: _withCtx(() => [
            (!_ctx.isNew)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        _cache[17] || (_cache[17] = _createElementVNode("h4", null, "Number of Children", -1)),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.diary ? _ctx.diary.totalChildrenCount : ""), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        _cache[18] || (_cache[18] = _createElementVNode("h4", null, "Monthly", -1)),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.monthlyChildrenCount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Spot", -1)),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.spotChildrenCount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 5,
          class: "d-flex mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "3" }),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.watchDate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.watchDate) = $event)),
                  label: "Date",
                  class: "mx-2"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.staffItems,
                  label: "Staff",
                  multiple: "",
                  "item-title": "name",
                  "item-value": "userId",
                  variant: "outlined",
                  clearable: "",
                  density: "compact",
                  modelValue: _ctx.inputValue.staff,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputValue.staff) = $event))
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.staffItems,
                  label: "Applicant",
                  "item-title": "name",
                  "item-value": "userId",
                  density: "compact",
                  variant: "outlined",
                  clearable: "",
                  modelValue: _ctx.inputValue.appliedBy,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputValue.appliedBy) = $event))
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_container, { class: "pt-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('nurseryHoursDiary.activityContent')), 1),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.inputValue.activity,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputValue.activity) = $event)),
                  variant: "outlined"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('nurseryHoursDiary.handoverContact')), 1),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.inputValue.message,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputValue.message) = $event)),
                  variant: "outlined"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('nurseryHoursDiary.remarks')), 1),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.inputValue.remarks,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputValue.remarks) = $event)),
                  variant: "outlined"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.isNew && _ctx.diary)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "py-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "8" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, null, {
                      default: _withCtx(() => [
                        _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "text-left" }, "Child Name"),
                            _createElementVNode("th", { class: "text-left" }, "Usage Type"),
                            _createElementVNode("th", { class: "text-left" }, "Departure Time")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diary.children, (childItem, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                              _createElementVNode("td", null, _toDisplayString(childItem.name), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getCategoryName(childItem.category)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(childItem.leftAt)), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 6,
          justify: "center",
          class: "mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.createDiary(true))),
              class: "mx-2",
              color: "primary",
              variant: "outlined",
              size: "large"
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode("Save as Draft", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.createDiary(false))),
              disabled: !_ctx.inputValue.appliedBy,
              class: "mx-2",
              color: "primary",
              size: "large",
              variant: "flat"
            }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createTextVNode("Create & Apply", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_row, {
          key: 7,
          justify: "center",
          class: "mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateDiary(false))),
              class: "mx-2",
              color: "primary",
              variant: "outlined",
              size: "large"
            }, {
              default: _withCtx(() => [
                (_ctx.isDraft)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Save as Draft"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, "Return"))
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateDiary(true))),
              disabled: !_ctx.inputValue.appliedBy,
              color: "primary",
              class: "mx-2",
              variant: "flat",
              size: "large"
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createTextVNode("Apply", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }))
  ]))
}